import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=2b1f2f88&scoped=true&"
import script from "./Shortcuts.vue?vue&type=script&lang=ts&"
export * from "./Shortcuts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f2f88",
  null
  
)

export default component.exports